export const cardBrands = {
  'visa': "VISA",
  'mastercard': "MASTERCARD",
  'diners-club': "DINERS_CLUB",
  'american-express': "AMERICAN_EXPRESS",
  'discover': "DISCOVER",
  'hipercard': "HIPERCARD",
  'maestro': "HIPERCARD",
  'elo': "ELO",
  'jcb': "JCB",
  'aura': "AURA",
};

export const brandNames = {
  "MASTERCARD": 'MASTERCARD',
  "VISA": 'VISA',
  "ELO": 'ELO',
  "AMERICAN_EXPRESS": 'AMERICAN EXPRESS',
  "DINERS_CLUB": 'DINERS CLUB',
  'JCB': 'JCB',
  'HIPERCARD': 'HIPERCARD'
}

export const cssBrands = {
  "MASTERCARD": 'mastercard',
  "VISA": 'visa',
  "ELO": 'elo',
  "AMERICAN_EXPRESS": 'american-express',
  "DINERS_CLUB": 'diners-club',
  'JCB': 'mastercard',
  'HIPERCARD': 'hipercard'
}

export const adyenCardBrands = {
  'mc': 'MASTERCARD',
  'visa': 'VISA',
  'diners': 'DINERS_CLUB',
  'amex': 'AMERICAN_EXPRESS',
  'discover': 'DISCOVER',
  'hipercard': 'HIPERCARD',
  'maestro': 'HIPERCARD',
  'elo': 'ELO',
  'jcb': 'JCB'
}

// MASTERCARD , VISA , ELO , AMERICAN_EXPRESS , DINERS_CLUB , JCB , HIPERCARD
